import { useEffect, useState } from "react";
import { Copy, KeyRound, Plug, RefreshCw, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export const McpCard = () => {
  const [t, setT] = useState(null);
  const load = () => api.get("/mcp/token").then((r) => setT(r.data));
  useEffect(() => { load(); }, []);
  const gen = async () => { const { data } = await api.post("/mcp/token"); setT(data); toast.success("Token gerado. O anterior deixou de funcionar."); };
  const revoke = async () => { if (!window.confirm("Revogar o token? O ChatGPT/Claude perderão o acesso.")) return; await api.delete("/mcp/token"); load(); };
  const copy = (v) => { navigator.clipboard.writeText(v); toast.success("Copiado"); };
  return (
    <section className="rounded-2xl border border-slate-200 bg-white p-6 lg:col-span-2" data-testid="mcp-card">
      <h2 className="font-display font-semibold text-xl flex items-center gap-2"><Plug size={18} className="text-[var(--blue)]" /> Conector MCP — ChatGPT & Claude</h2>
      <p className="text-sm text-slate-500 mt-1">Conecte uma vez e publique direto do chat: <em>"cria uma página assim… e publica no Lowpages como oferta-setembro"</em>. Ferramentas: list_pages, create_page, get_page, update_page, publish_page.</p>
      {t?.token ? (
        <div className="mt-5 grid md:grid-cols-2 gap-4">
          <div>
            <div className="text-xs font-medium text-slate-600 mb-1">URL do servidor MCP (contém seu token — trate como senha)</div>
            <div className="flex gap-2"><code data-testid="mcp-url" className="flex-1 rounded-xl bg-slate-50 border border-slate-200 px-3 py-2 text-xs font-mono break-all">{t.url}</code><button data-testid="mcp-copy" onClick={() => copy(t.url)} className="btn btn-ink !py-2 !px-3 text-xs"><Copy size={13} /></button></div>
            <div className="mt-3 flex gap-2"><button onClick={gen} className="btn btn-ghost !py-2 !px-3 text-xs"><RefreshCw size={13} /> Gerar novo</button><button data-testid="mcp-revoke" onClick={revoke} className="btn btn-ghost !py-2 !px-3 text-xs !text-red-600"><Trash2 size={13} /> Revogar</button></div>
          </div>
          <ol className="text-xs text-slate-600 space-y-2 list-decimal pl-4">
            <li><b>Claude</b> (web/desktop): Configurações → Conectores → Adicionar conector personalizado → cole a URL acima → sem autenticação adicional.</li>
            <li><b>ChatGPT</b> (Plus/Pro/Team, modo desenvolvedor): Configurações → Conectores → Criar → cole a URL → autenticação "Nenhuma".</li>
            <li>Peça: <em>"liste minhas páginas no Lowpages"</em> para testar.</li>
          </ol>
        </div>
      ) : (
        <button data-testid="mcp-generate" onClick={gen} className="btn btn-primary mt-5 !py-2.5"><KeyRound size={15} /> Gerar token de acesso</button>
      )}
    </section>
  );
};
